const { cxt } = require('./context');

const {
  banking,
} = require('../schema');

const {
  accountTransaction,
} = banking;

/**
 * Validates the Account Transaction
 * @type {Array<cxt>}
 * @memberof validators
 */
const accountTransactionValidator = [
  cxt('schema', { schema: accountTransaction, opts: { nestedErrors: true } }),
];

const narrationDescription = [
  cxt('max-length', { length: 50 }),
];

module.exports = {
  accountTransaction: accountTransactionValidator,
  narrationDescription,
};
